import { ENTITY_TYPE } from '@shared/constants';

/**
 * Returns true when the court-configured entity type is Individual (id 0).
 */
export function isIndividualEntityType(
  entityTypeId: number | null | undefined,
): boolean {
  return entityTypeId === ENTITY_TYPE.Individual;
}

/**
 * Returns true when the party should use the organization name form (any entity
 * type other than Individual, e.g. Organization, Agency).
 */
export function usesOrganizationPartyForm(
  entityTypeId: number | null | undefined,
): boolean {
  return entityTypeId != null && !isIndividualEntityType(entityTypeId);
}
